<div class="back-order-dialog-container">
    <div class="back-order-dialog-header-container">
        <div>  <p class="back-order-dialog-header-text back-order-section-headers">GO BACK?</p></div>
        <div><p class="back-order-dialog-sub-heading">Unsaved changes will be lost, are you sure?</p></div>
    </div>

    <div class="back-order-btn-dialog-container">

        <button class="cancel-back-order-dialog-btn" mat-flat-button type="button" (click)="cancelGoingbBack()">
            <div class="cancel-back-order-btn-content">
                <span><p class="cancel-back-order-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="order-back-btn mdc-button mdc-button--outlined"  type="button" routerLink="/order-manager/my-orders" (click)="goBack()">
            <div class="order-back-btn-content">
                <img src="../../../../../assets/order-to-cash-icons/arrow-back.svg" alt="Back Icon" class="order-back-btn-icon">
                <span><p class="order-back-btn-text">BACK</p></span>
            </div>
        </button>
    </div>

</div>
